module.exports = __webpack_public_path__ + "img/swiper-10.74d8bf22.png";